import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { Tabs, TabsPanel } from '@salesforce/design-system-react';
import {
  SelectionProfileAttributes,
  SelectionProfileStatus,
  SelectionProfileLocation
} from '../';

import * as Shapes from '../../constants/shapes';

import './SelectionProfile.scss';

class SelectionProfile extends Component {
  constructor(props) {
    super(props);
    this.getI18nID = suffix =>
      `components.ecs.selectionBrowser.profile.${suffix}`;
  }

  tabPanels(flags) {
    const { formatMessage } = this.props.intl;
    const panels = [];
    const labels = ['attribute', 'status', 'location'].reduce(
      (obj, current) => ({
        ...obj,
        [current]: formatMessage({ id: this.getI18nID(current) })
      }),
      {}
    );

    // Attributes
    const attributes = (
      <SelectionProfileAttributes profile={this.props.profile} />
    );
    panels.push(
      <TabsPanel key="attribute" label={labels.attribute}>
        {attributes}
      </TabsPanel>
    );

    // GDPR status
    if (flags.gdpr) {
      panels.push(
        <TabsPanel key="status" label={labels.status}>
          <SelectionProfileStatus
            actions={this.props.actions}
            auditLog={this.props.auditLog}
            profile={this.props.profile}
            isLoading={this.props.isLoading}
          />
        </TabsPanel>
      );
    }

    // Location
    if (this.props.rules?.data?.rules?.settings?.weather) {
      panels.push(
        <TabsPanel key="location" label={labels.location}>
          <SelectionProfileLocation location={this.props.location} />
        </TabsPanel>
      );
    }

    return panels.length > 1 ? panels : attributes;
  }

  render() {
    const panels = this.tabPanels(this.props.flags);
    let content = panels;
    if (Array.isArray(panels)) {
      content = <Tabs>{panels}</Tabs>;
    }
    return <div className="profile-pane">{content}</div>;
  }
}

SelectionProfile.propTypes = {
  actions: PropTypes.object,
  auditLog: PropTypes.array,
  profile: Shapes.Profile,
  location: Shapes.Location,
  subscriber: PropTypes.string,
  flags: Shapes.Flags,
  rules: PropTypes.object,
  isLoading: PropTypes.bool
};

export default injectIntl(SelectionProfile);
